export const Storage = {
  CREATE_EMPLOYEE_PERSON_ID: '@BrazaLink:create-employee-person-id',
  CURRENT_PROFILE: '@BrazaLink:currentProfile',
  LANGUAGE: '@BrazaLink:language',
  THEME: '@BrazaLink:theme',
  TOKENS: '@BrazaLink:tokens',
}
